import { fetchEpic, patchEpic } from "./epics"
import { combineEpics } from "redux-observable"

export const combinedEpics = combineEpics(
    fetchEpic,
    patchEpic,
)
export const InventoryConfigurationEpics = combinedEpics


// WEBPACK FOOTER //
// ./src/state/inventory/configuration/epics/index.ts